import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  host: {
    '[class]': 'getClass()'
  }
})
export class SidebarComponent implements OnInit {
  @Input() title: string;
  @Input() soundbite: string;
  @Input() description: string;
  @Input() showNavigation: boolean = false;
  @Input() isSticky: boolean;
  @Output() onNavigationEvent = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  navigationEvent(eventName: string) {
    this.onNavigationEvent.emit(eventName);
  }

  getClass() {
    return this.isSticky ? 'is-sticky' : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts